import { format, utcToZonedTime } from 'date-fns-tz'

export const currentLocalTime = (ianaTimezone: any, time = Date.now()) =>
  ianaTimezone
    ? format(utcToZonedTime(new Date(time), ianaTimezone), 'p')
    : format(new Date(time), 'p')

export const formatMinutes = (minutes: number) => {
  const hour = Math.floor(minutes / 60)
  const minute = minutes % 60
  return hour ? `${hour}h` : '' + minute ? `${minute}m` : ''
}

export const formatDate = (date: Date) => {
  const dayName = getDayName(date)
  const monthName = getMonthName(date)
  const hours = getHours(date)
  const minutes = date.getMinutes()
  const suffix = getTimeSuffix(date)
  const time = `${hours}:${minutes < 10 ? 0 : ''}${minutes} ${suffix}`
  const dateNumber = date.getDate()

  return `${dayName}, ${time}, ${monthName} ${dateNumber}`
}

// e.g. 8:00 am, 1:00 pm
export const formatTime = (date: Date) => {
  const hours = date.getHours() % 12 || 12
  const minutes = date.getMinutes()
  const suffix = getTimeSuffix(date)
  return `${hours}:${minutes < 10 ? 0 : ''}${minutes} ${suffix}`
}

export const getDayName = (date: Date) => {
  return DAY_NAMES[date.getDay()]
}

export const getMonthName = (date: Date) => {
  return MONTH_NAMES[date.getMonth()]
}

export const getHours = (date: Date) => {
  return date.getHours() % 12 || 12
}

export const getTimeSuffix = (date: Date) => {
  return date.getHours() < 12 ? 'am' : 'pm'
}

const DAY_NAMES = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
]

const MONTH_NAMES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]
